import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import { toast } from 'sonner';

export default function InstallPwa() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const isIos = typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent);
  const isStandalone = typeof window !== 'undefined' && (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (isStandalone) return null;

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    } else if (isIos) {
      toast.info('En iPhone: abre el menú Compartir de Safari y elige "Añadir a pantalla de inicio".', { duration: 6000 });
    } else {
      toast.info('Abre el menú de tu navegador y elige "Instalar app" o "Añadir a pantalla de inicio".', { duration: 6000 });
    }
  };

  return (
    <button
      onClick={handleInstall}
      data-testid="pwa-install-button"
      className="hidden items-center gap-2 rounded-full bg-cnib-navy px-4 py-2 text-xs font-bold text-white transition-colors hover:bg-cnib-blue sm:flex"
    >
      <Download className="h-3.5 w-3.5" />
      Instalar app
    </button>
  );
}
